import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/layout/AdminLayout';
import DashboardPage from './pages/DashboardPage';
import OrganizationsPage from './pages/OrganizationsPage';
import OrganizationDetailPage from './pages/OrganizationDetailPage';
import UsersPage from './pages/UsersPage';
import BugReportsPage from './pages/BugReportsPage';
import BugReportDetailPage from './pages/BugReportDetailPage';
import UsagePage from './pages/UsagePage';
import StoragePage from './pages/StoragePage';
import AuditLogsPage from './pages/AuditLogsPage';
import SecuritySettingsPage from './pages/SecuritySettingsPage';

export default function App() {
  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: { fontSize: '14px', borderRadius: '10px', padding: '12px 16px' },
        }}
      />
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="organizations" element={<OrganizationsPage />} />
            <Route path="organizations/:id" element={<OrganizationDetailPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="usage" element={<UsagePage />} />
            <Route path="storage" element={<StoragePage />} />
            <Route path="audit-logs" element={<AuditLogsPage />} />
            <Route path="settings/security" element={<SecuritySettingsPage />} />
            <Route path="bug-reports" element={<BugReportsPage />} />
            <Route path="bug-reports/:id" element={<BugReportDetailPage />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}